import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

import ClassicEditor from '@ckeditor-build/ckeditor.js';
import { Store } from '@ngrx/store';

import { WkKeywordService, WkTranslationService } from '../../../services';
import { CKEditorComponent } from '../../ckeditor/ckeditor.component';
import { CommonConstants } from '../../../shared/common.constant';
import { AppStore } from '../../../store/states';
import { SetKeywordEditorAction } from '../../../store/actions/app.custom-actions';

@Component({
  selector: 'wk-keyword-editor',
  templateUrl: './wk-keyword-editor.component.html',
  styleUrls: ['./wk-keyword-editor.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class WkKeywordEditorComponent implements OnInit {
  @ViewChild(CKEditorComponent)
  public keywordEditor: CKEditorComponent;
  public keywordEditorData: string;
  public wkKeywordEditor = ClassicEditor;
  public keywordPlugins: {};
  @Input()
  keywordEditorString;
  constructor(
    private readonly translate: WkTranslationService,
    private readonly wkKeywordService: WkKeywordService,
    private readonly store: Store<AppStore>
  ) {}

  ngOnInit(): void {
    this.getToolBarItemsForEditors(
      CommonConstants.miniEditorPlugins.toolbar.items
    );
  }

  getToolBarItemsForEditors(toolbarItems: string[]) {
    this.keywordPlugins = {
      toolbar: {
        items: toolbarItems.filter(
          (item) => item !== CommonConstants.CK_PLUGINS.INSERT_LINK
        ),
      },
      placeholder: this.translate.instant(
        `APP.KEYWORDS_DEFINITION.KEYWORD_PLACEHOLDER`
      ),
    };
  }

  onReady() {
    this.keywordEditorData = `${this.keywordEditorString}`;
    this.updateKeywordEditorData();
  }

  onChange() {
    if (!this.keywordEditorData) {
      /* Clear keyword editor field if user removes the existing data */
      this.keywordEditorData = null;
    }
    this.store.dispatch(new SetKeywordEditorAction(this.keywordEditorData));
    this.keywordEditor.editorInstance.focus();
  }

  updateKeywordEditorData() {
    this.keywordEditor.editorInstance.focus();
    this.wkKeywordService.setKeywordEditorInstance(this.keywordEditor);
  }
}
